import {action, observable, autorun} from 'mobx';

export class SubstitutionCompareCard {

  @observable isInComparator = true;
  @observable compareDisabled = false;

  constructor(skuID, rootStore) {
    this.skuID = skuID;
    this.comparatorStore = rootStore.comparatorStore;
    autorun(this.checkComparator);
  }

  checkComparator = () => {
    const isIn = this.comparatorStore.comparatorArr.findIndex(item => item === this.skuID) !== -1;

    isIn !== this.isInComparator && this.updateIsInComparator(isIn);
    this.updateCompareDisabled(isIn);
  };

  handleCompareClick = () => {
    this.isInComparator
      ? this.comparatorStore.removeFromCompare(this.skuID)
      : this.comparatorStore.addToCompare(this.skuID);
  };

  @action.bound
  updateCompareDisabled() {
    this.compareDisabled = this.comparatorStore.isComparatorFull && !this.isInComparator;
  }

  @action.bound
  updateIsInComparator(isIn) {
    this.isInComparator = isIn;
  }
}
